
import { getContainerById } from "@/service/container.service";
import { Container } from "@/types/container.type";
import { defineComponent, isProxy, PropType, ref } from "@vue/runtime-core";
import infoItemComponent from "../infoItem.component.vue";

export default defineComponent({
  components: { infoItemComponent },
  props: {
    id: {
      type: Number,
      required: true,
    },
    containerData: {
      type: Object as PropType<Container>,
    },
  },
  data() {
    return {
      entity: ref({} as undefined | Container),
    };
  },
  async mounted() {
    if (isProxy(this.containerData)) {
      // - set from property
      this.entity = this.containerData;
    } else if (this.id) {
      // - set from service
      this.entity = await getContainerById(this.id);
    }
  },
  watch: {
    containerData: {
      handler(val) {
        // - over property
        this.entity = val;
      },
      deep: false,
    },
  },
});
